import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetConnectUserInfoOverridesResponse extends BackendResponse {
  item: ConnectUserInfoOverrides;
}

export interface GetConnectUserInfoOverridesParameters extends NextApiParams {}

export const getConnectUserInfoOverrides = withNextApi<
  GetConnectUserInfoOverridesResponse,
  GetConnectUserInfoOverridesParameters
>("/auth/GetConnectUserInfoOverrides", { method: "GET" });

export interface ConnectUserInfoOverrides {
  tryAttachProfileOnLogin: boolean;
  detachProfileOnLogin: boolean;
  firstname: string | null;
  lastname: string | null;
  name: string | null;
  email: string | null;
  phoneNumber: string | null;
  emailVerified: string | null;
  phoneVerified: string | null;
  _connectUserInfoId: string | null;
}
